import { GetBadgeBottomSheet } from "@src/appV2/redesign/IndependantContractorBadge/BottomSheet/GetBadgeBottomSheet";
import { AnalyticsOpenFromValues } from "@src/appV2/redesign/IndependantContractorBadge/constants";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useRef } from "react";

import { PageWrapper } from "../../../components/PageWrapper";
import { StickyScrollPageHeader } from "../../../components/StickyScrollPageHeader";
import { DocumentPageScrollWrapper } from "../../Details/ScrollWrapper";
import { InfoStep } from "./components/InfoStep";
import { QualificationSelectionStep } from "./components/QualificationSelectionStep";
import { StateSelectionStep } from "./components/StateSelectionStep";
import { StepFooter } from "./components/StepFooter";
import { BadgeStep, STEP_TITLES } from "./constants";
import { useBadgeFlow } from "./hooks/useBadgeFlow";

export function IndependentContractorBadgePageV2() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const {
    state,
    actions,
    activeQualifications,
    selectedQualification,
    selectedQualificationHasMultipleLicenses,
    isLoadingQualifications,
    badgeBottomSheetModalState,
    selectedQualificationWithLicense,
  } = useBadgeFlow();

  const worker = useDefinedWorker();

  return (
    <PageWrapper variant="tertiary">
      <StickyScrollPageHeader
        shouldWrapTitle
        title={STEP_TITLES[state.currentStep]}
        headerVariant="tertiary"
        scrollContainerRef={scrollRef}
        onClickBack={() => {
          actions.handleClickBack();
        }}
      />
      <DocumentPageScrollWrapper ref={scrollRef} height="100%">
        {state.currentStep === BadgeStep.INFO && <InfoStep isLoading={isLoadingQualifications} />}

        {state.currentStep === BadgeStep.QUALIFICATION_SELECTION && (
          <QualificationSelectionStep
            state={state}
            actions={actions}
            activeQualifications={activeQualifications}
          />
        )}

        {state.currentStep === BadgeStep.STATE_SELECTION && (
          <StateSelectionStep
            state={state}
            actions={actions}
            selectedQualification={selectedQualification}
          />
        )}
      </DocumentPageScrollWrapper>
      <StepFooter
        state={state}
        actions={actions}
        selectedQualificationHasMultipleLicenses={selectedQualificationHasMultipleLicenses}
        isLoadingQualifications={isLoadingQualifications}
      />
      <GetBadgeBottomSheet
        modalState={badgeBottomSheetModalState}
        // We only trigger this bottom sheet when user has selected a qualification, so "" case won't ever happen
        qualification={selectedQualificationWithLicense?.qualification.attributes.name ?? ""}
        state={selectedQualificationWithLicense?.license?.attributes.state ?? ""}
        analyticsMetadata={{
          role: selectedQualificationWithLicense?.qualification.attributes.name,
          workerId: worker.userId,
          workerFullName: `${worker.firstName} ${worker.lastName}`,
          openedFrom: AnalyticsOpenFromValues.PROFILE,
          state: selectedQualificationWithLicense?.license?.attributes.state,
        }}
      />
    </PageWrapper>
  );
}
